import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDocumentTypeState } from "../../../types/documentTypes/documentTypeInterfaces";
import { DropdownWithCodeDTO } from "../../../types/common/DropdownWithCodeDTO";

export const initialState: IDocumentTypeState = {
  documentTypeDropdown: []
};

export const documentTypeSlice = createSlice({
  name: 'documentType',
  initialState,
  reducers: {
    loadingDocumentTypeDropdown: (state, action: PayloadAction<DropdownWithCodeDTO[]>) => {
      state.documentTypeDropdown = action.payload;
    },
  }
});

export const { loadingDocumentTypeDropdown } = documentTypeSlice.actions;

export default documentTypeSlice.reducer;
